(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("Web3WalletConnector", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Web3WalletConnector"] = factory(require("react"), require("react-dom"));
	else
		root["Web3WalletConnector"] = factory(root["React"], root["ReactDOM"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__12244__, __WEBPACK_EXTERNAL_MODULE__53741__) {
return 